import { render } from "./Listen.vue?vue&type=template&id=98b46290&scoped=true"
const script = {}

import "./Listen.vue?vue&type=style&index=0&id=98b46290&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98b46290"]])

export default __exports__